import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-10" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 mb-2" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-6 mb-2" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-6 mb-2" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_15 = { class: "col-md-6 mb-2" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = { class: "upload-container" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "text-center"
}
const _hoisted_21 = { class: "col-md-12 m-10" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "border border-primary mb-10" }
const _hoisted_24 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_25 = { class: "col-md-5" }
const _hoisted_26 = { class: "d-flex float-end" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "col-md-4 mb-2" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "col-md-2 mb-2" }
const _hoisted_31 = { class: "input-group" }
const _hoisted_32 = ["onUpdate:modelValue", "onInput"]
const _hoisted_33 = { class: "input-group-text" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "col-md-2 mb-2" }
const _hoisted_36 = ["onUpdate:modelValue", "onInput"]
const _hoisted_37 = { class: "col-md-2 mb-2" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "col-md-2 mb-2" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "col-md-12 mt-3" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Enregistrement du bon de commande fournisseur")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addBon,
        "keep-values": _ctx.valuess,
        "validation-schema": _ctx.bonSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Date Com Four. "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateOperation",
                          modelValue: _ctx.dateOperation,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOperation) = $event)),
                          type: "datetime-local",
                          max: _ctx.currentDateTime,
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Date oper."
                        }, null, 8, ["modelValue", "max"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "dateOperation",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Référence du document "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "refDoc",
                          modelValue: _ctx.refDoc,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refDoc) = $event)),
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Référence"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "refDoc",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Fournisseur "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Multiselect, {
                          options: _ctx.fournisseurOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: _ctx.fournisseur,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fournisseur) = $event)),
                            _cache[3] || (_cache[3] = (val) => { _ctx.fournisseur = val; _ctx.fournisseurError = ''; })
                          ],
                          placeholder: "Sélectionner le fournisseur"
                        }, null, 8, ["options", "modelValue"]),
                        (_ctx.fournisseurError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.fournisseurError), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Montant total ", -1)),
                        _createVNode(_component_Field, {
                          name: "montantTotal",
                          type: "number",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Montant total calculé",
                          modelValue: _ctx.montantTotal,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montantTotal) = $event)),
                          readonly: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Image du bon ", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[5] || (_cache[5] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/jpeg, image/png, image/jpg",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_19))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[13] || (_cache[13] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "icofont icofont-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image du bon ")
                          ]))),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "delete-btn",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, _cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-4 text-black" }, "Les produits")
                    ], -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addRowProduit()))
                        }, _cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode(" Ajouter un produit ")
                        ]), 10, _hoisted_27)
                      ])
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row gx-2 mt-2 fw-semibold" }, [
                    _createElementVNode("div", { class: "col-md-4" }, "Produit"),
                    _createElementVNode("div", { class: "col-md-2" }, "Quantité"),
                    _createElementVNode("div", { class: "col-md-2" }, "Prix Unitaire"),
                    _createElementVNode("div", { class: "col-md-2" }, "Montant"),
                    _createElementVNode("div", { class: "col-md-2" }, "Action")
                  ], -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "mt-1" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row gx-2",
                      key: produitIndex
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Multiselect, {
                          modelValue: produit.produit,
                          "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                          options: _ctx.listeProduitDisponible(produitIndex),
                          searchable: true,
                          placeholder: "Sélectionner un produit",
                          onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit)),
                          class: _normalizeClass(_ctx.validateRowProduit(produit.produit)
                                                ? 'fs-md-15 text-black is-invalid'
                                                : 'fs-md-15 text-black')
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSelect", "class"]),
                        (_ctx.validateRowProduit(produit.produit))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Le produit est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((produit.qteBon) = $event),
                            onInput: ($event: any) => (_ctx.calculMontant(produit)),
                            class: _normalizeClass(_ctx.validateRowProduit(produit.qteBon)
                                                    ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                                    : 'form-control shadow-none fs-md-15 text-black'),
                            placeholder: "Quantité"
                          }, null, 42, _hoisted_32), [
                            [_vModelText, produit.qteBon]
                          ]),
                          _createElementVNode("span", _hoisted_33, _toDisplayString(produit.uniteMesure != null
                                                    ? produit.uniteMesure.replace("[", "").replace("]", "")
                                                    : 'UM'), 1)
                        ]),
                        (_ctx.validateRowProduit(produit.qteBon))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, " La quantité est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((produit.prix) = $event),
                          onInput: ($event: any) => (_ctx.calculMontant(produit)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Prix unitaire"
                        }, null, 40, _hoisted_36), [
                          [_vModelText, produit.prix]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((produit.montant) = $event),
                          readonly: "",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Montant"
                        }, null, 8, _hoisted_38), [
                          [_vModelText, produit.montant]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeRowProduit(produitIndex))
                        }, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                        ]), 8, _hoisted_40)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", {
                  ref: "submitButton",
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Enregistrer le bon ", 8, _hoisted_43),
                _createVNode(_component_router_link, {
                  to: "/bons-commandefournisseurs/liste-commandefournisseurs",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "keep-values", "validation-schema"])
    ])
  ]))
}